(function () {
  async function atualizarSacoCurvie() {
    try {
      const resposta = await fetch('/cart?view=ajax-drawer');
      if (!resposta.ok) return;

      const html = await resposta.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const sacoNovo = doc.querySelector('.curvie-saco-presente');

      document.querySelectorAll('.cart--root').forEach(function (carrinho) {
        const sacoAntigo = carrinho.querySelector('.curvie-saco-presente');
        const rodape = carrinho.querySelector('.cart--footer');

        if (sacoAntigo) sacoAntigo.remove();

        if (sacoNovo && rodape) {
          rodape.before(sacoNovo.cloneNode(true));
        }
      });
    } catch (erro) {
      console.error('Erro ao atualizar Saco Curvie:', erro);
    }
  }

  window.addEventListener('theme:cart:updated', atualizarSacoCurvie);
})();